
document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-radio]')){
    const section=e.target.closest('[data-product-section]');
    const image=section.querySelector('[data-product-image]');
    const price=section.querySelector('[data-product-price]');
    const btn=section.querySelector('[data-add-button]');
    if(e.target.dataset.image && image) image.src=e.target.dataset.image;
    if(e.target.dataset.price && price) price.textContent=e.target.dataset.price;
    if(btn) btn.disabled=e.target.dataset.available!=='true';
  }
});
